const NerpyIcon = require('static/nerpy.png');

const tokens = {
    colors: {
        nearpeer: '#25215f',
        nearpeerDark: '#171340',
        nearpeerSoft: '#f7f5ff',
        white: '#ffffff',
        text: '#25215f',
        textMuted: '#625d83',
        panelText: '#f8f8ff',
        panelMuted: 'rgba(255, 255, 255, .68)',
        panelBorder: 'rgba(255, 255, 255, .16)',
        panelSurface: 'rgba(255, 255, 255, .08)',
        panelJson: 'rgba(0, 0, 0, .30)',
        successText: '#dfffe9',
        cardBorder: 'rgba(37, 33, 95, .12)',
        rowBorder: 'rgba(37, 33, 95, .08)'
    },
    radii: {
        sm: 8,
        md: 12,
        lg: 18,
        pill: '50%'
    },
    shadows: {
        card: '0 12px 34px rgba(31, 28, 76, .08)',
        panel: '0 18px 70px rgba(0, 0, 0, .44)',
        launcher: '0 12px 34px rgba(0, 0, 0, .32)'
    },
    spacing: {
        xs: 6,
        sm: 8,
        md: 12,
        lg: 16,
        xl: 18,
        xxl: 24
    },
    fonts: {
        mono: 'Menlo, Monaco, Consolas, monospace'
    },
    zIndex: {
        console: 2147483647
    }
};

const shared = {
    card: {
        border: `1px solid ${tokens.colors.cardBorder}`,
        borderRadius: tokens.radii.lg,
        background: tokens.colors.white,
        boxShadow: tokens.shadows.card
    },
    panelButton: {
        border: '1px solid rgba(255, 255, 255, .18)',
        borderRadius: tokens.radii.sm,
        background: tokens.colors.panelSurface,
        color: tokens.colors.white,
        cursor: 'pointer',
        fontSize: 12,
        padding: '7px 10px'
    },
    actionLink: {
        color: tokens.colors.nearpeer,
        textDecoration: 'none'
    }
};

module.exports = {
    NerpyIcon,
    tokens,
    shared,
    createTeamConsoleStyles,
    createInternalConsoleStyles: createTeamConsoleStyles
};

function createTeamConsoleStyles() {

    const baseCard = shared.card;

    return {
        page: {
            width: '100%',
            maxWidth: 1180,
            margin: '0 auto',
            padding: '28px 22px 60px',
            color: tokens.colors.text
        },
        hero: {
            ...baseCard,
            display: 'flex',
            justifyContent: 'space-between',
            gap: 20,
            padding: tokens.spacing.xxl,
            background: `linear-gradient(135deg, ${tokens.colors.nearpeerSoft}, ${tokens.colors.white})`
        },
        brand: {
            display: 'flex',
            gap: tokens.spacing.xl,
            alignItems: 'center'
        },
        nerpy: iconStyle(78),
        eyebrow: labelText(),
        title: {
            margin: '4px 0 6px',
            fontSize: 34,
            lineHeight: 1.1
        },
        description: {
            margin: 0,
            maxWidth: 560,
            color: '#565179'
        },
        scopeCard: {
            ...baseCard,
            minWidth: 220,
            padding: tokens.spacing.xl,
            alignSelf: 'stretch'
        },
        scopeLabel: labelText(),
        scopeValue: {
            marginTop: tokens.spacing.sm,
            fontSize: 22,
            fontWeight: 800
        },
        scopeMeta: {
            marginTop: tokens.spacing.sm,
            color: '#615d7f'
        },
        grid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(170px, 1fr))',
            gap: tokens.spacing.md,
            marginTop: tokens.spacing.xl
        },
        metricEnabled: {
            ...baseCard,
            padding: tokens.spacing.lg
        },
        metricDisabled: {
            ...baseCard,
            padding: tokens.spacing.lg,
            opacity: .48
        },
        metricLabel: {
            display: 'block',
            fontSize: 12,
            textTransform: 'uppercase',
            letterSpacing: '.06em'
        },
        metricValue: {
            display: 'block',
            marginTop: tokens.spacing.sm
        },
        section: {
            marginTop: 28
        },
        sectionTitle: {
            margin: '0 0 12px',
            fontSize: 22
        },
        actionsGrid: {
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
            gap: 14
        },
        actionCard: {
            ...baseCard,
            ...shared.actionLink,
            display: 'flex',
            flexDirection: 'column',
            gap: tokens.spacing.sm,
            minHeight: 118,
            padding: tokens.spacing.xl
        },
        actionLabel: {
            fontSize: 18,
            fontWeight: 800
        },
        actionDescription: {
            color: tokens.colors.textMuted,
            lineHeight: 1.45
        },
        empty: {
            ...baseCard,
            padding: tokens.spacing.xl,
            color: tokens.colors.textMuted
        },
        details: {
            ...baseCard,
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
            gap: 0,
            margin: 0,
            padding: 0,
            overflow: 'hidden'
        },
        row: {
            padding: tokens.spacing.lg,
            borderBottom: `1px solid ${tokens.colors.rowBorder}`
        },
        rowLabel: {
            ...labelText(),
            margin: 0
        },
        rowValue: {
            margin: '6px 0 0',
            fontWeight: 700
        }
    };
}

function iconStyle(size) {

    return {
        display: 'block',
        width: size,
        height: size,
        objectFit: 'contain'
    };
}

function labelText() {

    return {
        fontSize: 12,
        fontWeight: 700,
        textTransform: 'uppercase',
        letterSpacing: '.06em',
        opacity: .65
    };
}
